import { pathSubscription } from 'nike-re-framejs';

export const serverInfoOdstavka$ = pathSubscription(['serverInfo', 'odstavka']);
export const serverIsOdstavkaClosed$ = odstavkaId =>
    pathSubscription(['serverInfo', 'odstavkaClosed', odstavkaId], false);
